module.exports = __webpack_public_path__ + "static/media/image_12.8ff8ad92.png";